module.exports = __webpack_public_path__ + "static/media/repeat-alt.8aebf103.svg";